import isMobile from 'ismobilejs';
import qs from './util/DOM/qs';

const selectors = {
	scrollable: '.scrollable'
};

export default () => {
	if (isMobile.apple.phone) {
		const ScrollFix = require('scrollfix');
		const scrollable = qs(selectors.scrollable);
		new ScrollFix(scrollable); // eslint-disable-line
	}
};
